
type Props = {}

const SetUpView = (props: Props) => {
  return (
    <div>SetUpView</div>
  )
}

export default SetUpView